// extracted by mini-css-extract-plugin
module.exports = {"newsRoot":"y13z8GcK","newsTitle":"Lilbhsez"};